import { useEffect, useState } from "react";
import { CircularProgress, Box, Typography } from "@mui/material";
import { LegitCheckItem } from "../../types/types";
import LegitCheckService from "../../services/legitCheckService";
import LegitCheckResultElement from "./LegitCheckResultElement";

interface LegitCheckResultResultsProps {
  itemId: number;
  legitChecks?: Array<LegitCheckItem>;
}

const LegitCheckResults = ({
  itemId,
  legitChecks,
}: LegitCheckResultResultsProps) => {
  const [lcResults, setLcResults] = useState<Array<LegitCheckItem> | undefined>(
    legitChecks ? legitChecks : undefined
  );

  const { getLegitChecks } = LegitCheckService();

  useEffect(() => {
    if (legitChecks === undefined) {
      getLegitChecks(itemId).then((results) => {
        if (results) {
          setLcResults(results);
        }
      });
    }
  }, [itemId]);

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      {lcResults ? (
        lcResults.length > 0 ? (
          lcResults.map((lc) => <LegitCheckResultElement legitCheck={lc} />)
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
            }}
          >
            <Typography variant="body1">
              {"This shirt hasn't been legit checked yet by VIP collectors."}
            </Typography>
          </Box>
        )
      ) : (
        <CircularProgress />
      )}
    </Box>
  );
};

export default LegitCheckResults;
